export default __webpack_public_path__ + "static/media/bronce.b042076e.png";